import React, { useContext } from 'react'
import { store, actions } from '../../stores/multipost'
import { accountTypes } from '../Share/SocialAccountsSelector'
import TextareaAutosize from 'react-textarea-autosize'

export default function ProviderMessage({ provider }) {
  const { dispatch, selectedAccounts, messages } = useContext(store)
  const accountType = accountTypes[provider]
  const disabled = !selectedAccounts.includes(provider)
  const maxLength = accountTypes[provider].max
  const length = messages[provider]?.value?.length || 0
  const overLength = length > maxLength
  const displayLength = overLength ? maxLength - length : length

  const onChange = (e) => {
    dispatch({
      type: actions.SET_MESSAGES,
      messages: {
        ...messages,
        [provider]: {
          value: e.target.value,
          overLength: e.target.value.length > maxLength,
        },
      },
    })
  }

  return (
    <>
      <div className="p-2 border-bottom border-top d-flex justify-content-between align-items-center bg-muted" style={{background: 'rgba(248, 248, 248, 0.5)'}}>
        <span className="text-muted text-uppercase fw-bold ms-2" style={{fontSize: '0.75rem'}}>{accountType.label} Message</span>
        <div className={overLength ? 'text-danger' : 'text-muted'}>
          {displayLength}/{maxLength}
        </div>
      </div>
      <TextareaAutosize
        className="form-control border-0 shadow-none p-3"
        id={`messages-${provider}`}
        name={`team_post[messages][${provider}]`}
        minRows={7}
        placeholder="This message is optional…"
        value={messages[provider]?.value || messages.default.value || ''}
        onChange={onChange}
        disabled={disabled}
      />
    </>
  )
}